export default __webpack_public_path__ + "static/media/covid-app.b6b3b616.PNG";